module.exports = __webpack_public_path__ + "img/software4.d96cedd6.jpg";